// Copyright (c) 2020 Deere & Company

import './index.scss';

import * as busyCounter from '../../shared/action-creator/busy-counter';
import React, { Component } from 'react';
import { createErrorMessage, createSuccessMessage } from '../../shared/action-creator/alert-messages';
import {
    getBeginWeeks, getEndWeeks
} from '../../common/repositories';
import { getPackageCodes, getPoolInvResults } from './repositories';
import BusyCounterLoadingIndicator from '../../shared/components/busyCounter/busy-counter-loading-indicator';
import OptionsDropDown from '../../shared/components/options-drop-down';
import PoolInventoryByPoolPkgCodeTable from './components/pool-inventory-by-pool-pkg-code-table';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { formatGivenDate } from '../../shared/services/common-functions';
import { showLoadingIndicator } from '../../shared/state/busy-counter';
import { withRouter } from 'react-router-dom';

class PoolInventoryByPoolPkgCode extends Component {

    state = {
        packageCodes: [],
        selectedPkgName: '',
        results: null,
        beginWeeks: [],
        endWeeks: [],
        selectedBeginWeek: '',
        selectedEndWeek: ''
    };

    componentDidMount = () => {

        const query = new URLSearchParams( this.props.location.search );
        const queryPkgCode = query.get( 'packagecode' );
        const queryBeginWeek = query.get( 'beginweek' );
        const queryEndWeek = query.get( 'endweek' );
        this.handleQueryParams( queryPkgCode,
            queryBeginWeek, queryEndWeek );

    }

    componentDidUpdate = prevProps => {

        if ( this.props.location.search !== prevProps.location.search ) {

            const query = new URLSearchParams( this.props.location.search );
            const queryPkgCode = query.get( 'packagecode' );
            const queryBeginWeek = query.get( 'beginweek' );
            const queryEndWeek = query.get( 'endweek' );
            this.handleQueryParams( queryPkgCode,
                queryBeginWeek, queryEndWeek );
            window.scrollTo( 0, 0 );

        }

    }

    handleQueryParams ( queryPkgCode, queryBeginWeek, queryEndWeek ) {

        this.props.increaseCounter();
        getPackageCodes( ).then( response => {

            const pkgCode = response.map( i => ( { id: i.id.trim(), value: i.value.trim() } ) );
            this.setState( {
                packageCodes: pkgCode
            } );
            this.props.decreaseCounter();

            if ( queryPkgCode ) {

                this.setState( {
                    selectedPkgName: queryPkgCode
                } );

            }

        } ).catch( () => {

            this.props.decreaseCounter();

        } );
        if ( ( this.state.selectedPkgName !== '-1' ) || ( queryPkgCode ) ) {

            this.props.increaseCounter();
            getBeginWeeks( ).then( response => {

                const bWeeks = response.map( i => {

                    const wk = formatGivenDate( i.beginWeek, 'YYYY-MM-DD' );
                    let wkn = wk;
                    if ( wk === '2000-01-01' ) wkn = 'Inventory';
                    if ( wk === '2000-02-01' ) wkn = 'Rework';
                    return { id: wk, value: wkn };

                } );
                this.setState( {
                    beginWeeks: bWeeks
                } );
                if ( queryBeginWeek ) {

                    this.setState( {
                        selectedBeginWeek: queryBeginWeek
                    } );
                    getEndWeeks( queryBeginWeek ).then( endWeekResponse => {

                        const eWeeks = endWeekResponse.map( i => {

                            const wk = formatGivenDate( i.endWeek, 'YYYY-MM-DD' );
                            let wkn = wk;
                            if ( wk === '2000-01-01' ) wkn = 'Inventory';
                            if ( wk === '2000-02-01' ) wkn = 'Rework';
                            return { id: wk, value: wkn };

                        } );
                        this.setState( {
                            endWeeks: eWeeks,
                            selectedEndWeek: queryEndWeek,
                            results: null
                        }, () => {

                            this.refresh();

                        } );
                        this.props.decreaseCounter();

                    } ).catch( () => {

                        this.props.decreaseCounter();

                    } );

                }
                this.props.decreaseCounter();

            } ).catch( () => {

                this.props.decreaseCounter();

            } );

        }

    }

    handlePkgCodeChange ( val ) {

        this.setState( {
            selectedPkgName: val,
            results: null,
            selectedBeginWeek: '',
            selectedEndWeek: ''

        } );

    }

    handleBeginWeekChange ( val ) {

        this.setState( {
            selectedBeginWeek: val,
            selectedEndWeek: '',
            results: null
        }, () => {

            if ( this.state.selectedBeginWeek !== '-1' ) {

                this.props.increaseCounter();
                getEndWeeks( val ).then( response => {

                    const eWeeks = response.map( i => {

                        const wk = formatGivenDate( i.endWeek, 'YYYY-MM-DD' );
                        let wkn = wk;
                        if ( wk === '2000-01-01' ) wkn = 'Inventory';
                        if ( wk === '2000-02-01' ) wkn = 'Rework';
                        return { id: wk, value: wkn };

                    } );
                    this.setState( {
                        endWeeks: eWeeks,
                        selectedEndWeek: '',
                        results: null
                    } );
                    this.props.decreaseCounter();

                } ).catch( () => {

                    this.props.decreaseCounter();

                } );

            }

        } );

    }

    handleEndWeekChange ( val ) {

        this.setState( {
            selectedEndWeek: val
        }, () => {

            this.refresh();

        } );

    }

    handlePoolInvByPkgCode ( packageName, beginWeek, endWeek ) {

        this.props.increaseCounter();
        getPoolInvResults( packageName, beginWeek, endWeek )
            .then( response => {

                this.setState( {
                    results: response
                } );

                this.props.decreaseCounter();

            } ).catch( () => {

                this.props.decreaseCounter();

            } );

    }

    refresh () {

        this.handlePoolInvByPkgCode( this.state.selectedPkgName,
            this.state.selectedBeginWeek, this.state.selectedEndWeek );

    }

    render () {

        const {
            selectedPkgName, packageCodes, selectedBeginWeek,
            selectedEndWeek, beginWeeks, endWeeks, results
        } = this.state;

        const mapResults = [];
        let k = 1;
        let orderingcodeQty = 0;
        let orders = 0;
        if ( results !== null && results !== undefined ) {

            for ( let i = 0; i < results.length; i += 1 ) {

                const resultWithUnitName = results[i].poolInventoryList.map( order => (
                    { ...order, buildWeekString: formatGivenDate( order.buildWeek, 'YYYY-MM-DD' ), ...{ unitName: this.props.unit.name } } ) );
                orders += resultWithUnitName.length;
                const orderQtyforGrid = results[i].orderQuantity;
                orderingcodeQty += results[i].orderQuantity;
                const totalOrderForGrid = resultWithUnitName.length;
                resultWithUnitName[totalOrderForGrid] = { model: '0', message: `Total Orders: ${totalOrderForGrid} and Total Ordering Quantity: ${orderQtyforGrid}` };
                mapResults[k] = resultWithUnitName;
                mapResults[k].buildWeek = results[i].buildWeek;
                k += 1;

            }

        }

        return (
            <section className="main-content">
                <BusyCounterLoadingIndicator busyCounter={this.props.busyCounter} />
                {/* <Breadcrumbs crumbs={crumbs} /> */}
                <header>
                    <h2 className="page-header">Check Pool Inventory By Package Code</h2>
                </header>

                <main>
                    <section className="section-container">
                        <div className="atp-top-options atp-pool-inv-by-pool-pkg-code-options">
                            <div className="select-options">
                                <OptionsDropDown
                                    className="atp-pool-inv-by-pkg-code-select"
                                    label="Pkg Code"
                                    isPlaceholderTranslated={true}
                                    onChange={this.handlePkgCodeChange.bind( this )}
                                    optionDisplayAttributes={['value']}
                                    optionKey="id"
                                    options={packageCodes}
                                    placeholder="Select Package Code"
                                    selectedValue={selectedPkgName}
                                />
                                {selectedPkgName && selectedPkgName !== '-1' && (
                                    <OptionsDropDown
                                        className="atp-pool-inv-by-pkg-code-select"
                                        label="Begin Week"
                                        isPlaceholderTranslated={true}
                                        onChange={this.handleBeginWeekChange.bind( this )}
                                        optionDisplayAttributes={['value']}
                                        optionKey="id"
                                        options={beginWeeks}
                                        placeholder="Select Begin Week"
                                        selectedValue={selectedBeginWeek}
                                    />
                                )}
                                {selectedPkgName && selectedBeginWeek && selectedBeginWeek !== '-1' && (
                                    <OptionsDropDown
                                        className="atp-pool-inv-by-pkg-code-select"
                                        label="End Week"
                                        isPlaceholderTranslated={true}
                                        onChange={this.handleEndWeekChange.bind( this )}
                                        optionDisplayAttributes={['value']}
                                        optionKey="id"
                                        options={endWeeks}
                                        placeholder="Select End Week"
                                        selectedValue={selectedEndWeek}
                                    />
                                )}

                                {selectedPkgName && selectedBeginWeek && selectedEndWeek && <span onClick={this.refresh.bind( this )}><i className="icon fa fa-refresh" /></span>}

                            </div>
                        </div>
                        <section className="messagecontainer">
                            {results !== null && (
                                <div className="displaydate"> Status as of {Date()}</div>
                            ) }
                            {results !== null && (
                                <div className="displayErrorMessage">Total Orders for Time Period: {orders} and Total Ordering Quantity for Time Period: {orderingcodeQty}</div>
                            ) }
                        </section>
                        {results !== null && mapResults !== undefined && mapResults.map( ( item, index ) => (
                            <PoolInventoryByPoolPkgCodeTable
                                key={`pool-inventory-${item.buildWeek}-${index}`}
                                results={item}
                                buildWeek={item.buildWeek}
                            />
                        ) ) }
                    </section>
                </main>
            </section>
        );

    }

}

const mapStateToProps = state => ( {
    busyCounter: showLoadingIndicator( state.application.busyCounter ),
    unit: state.application.unit,
    accessToken: state.oktaState.oktaState.accessToken
} );

PoolInventoryByPoolPkgCode.displayName = 'PoolInventoryByPoolPkgCode';
PoolInventoryByPoolPkgCode.propTypes = {
    busyCounter: PropTypes.bool.isRequired,
    increaseCounter: PropTypes.func.isRequired,
    decreaseCounter: PropTypes.func.isRequired,
    unit: PropTypes.object,
    location: PropTypes.object
};
const mapDispatchToProps = dispatch => ( {
    increaseCounter: () => dispatch( busyCounter.increaseBusyCounter() ),
    decreaseCounter: () => dispatch( busyCounter.decreaseBusyCounter() ),
    createSuccessMessage: message => dispatch( createSuccessMessage( message ) ),
    createErrorMessage: message => dispatch( createErrorMessage( message ) )
} );
export default connect(
    mapStateToProps, mapDispatchToProps
)( withRouter( PoolInventoryByPoolPkgCode ) );
